import React, { Component } from 'react';

class ScrollListHorizontal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showArrows: true
        }

        this.elmLista = React.createRef();

        this.onClickArrowLeft = this.onClickArrowLeft.bind(this);
        this.onClickArrowRight = this.onClickArrowRight.bind(this);
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.onResize);
        this.verifyShowArrows();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize)
    }

    onResize() {
        this.verifyShowArrows();
    }

    verifyShowArrows() {
        if (this.elmLista && this.elmLista.current) {
            var padding = 72;
            var show = (this.elmLista.current.scrollWidth - padding) > this.elmLista.current.clientWidth;
            this.setState({ showArrows: show });
        }
    }

    getItemWidth() {
        return this.props.itemWidth || 200;
    }

    onClickArrowLeft() {
        var elmLst = this.elmLista.current;

        var itemWidth = this.getItemWidth();
        var itemIdx = Math.floor(elmLst.clientWidth / itemWidth);
        var scrollPos = Math.max(0, elmLst.scrollLeft - (itemIdx * itemWidth));
        elmLst.scrollTo({
            left: scrollPos,
            behavior: 'smooth'
        });

        // var deslocamento = 20; //0-100
        // var scrollPos = elmLst.scrollLeft - ((deslocamento / 100) * elmLst.scrollWidth);
        // scrollPos = Math.max(scrollPos, 0);
        // elmLst.scrollTo({
        //     left: scrollPos,
        //     behavior: 'smooth'
        // });
    }

    onClickArrowRight() {
        var elmLst = this.elmLista.current;

        var itemWidth = this.getItemWidth();
        var itemIdx = Math.floor(elmLst.clientWidth / itemWidth);
        var scrollPos = Math.min(elmLst.scrollLeft + (itemIdx * itemWidth), elmLst.scrollWidth);
        elmLst.scrollTo({
            left: scrollPos,
            behavior: 'smooth'
        });
    }

    render() {



        const listItems = (this.props.items || []).map((item, index) => (<div key={`scrollH-item-${index}`} style={{ width: this.getItemWidth(), display: "inline-block" }}>
            {item}
        </div>));

        return (<div className="lista-trilha-conteudo-container">
            <div className="lista-trilha-conteudo-itens" ref={this.elmLista}>
                {listItems}
            </div>
            {this.state.showArrows && <div className="left-arrow" onClick={this.onClickArrowLeft}>
                <i className="fas fa-angle-left edb-xxxlarge"></i>
            </div>}
            {this.state.showArrows && <div className="right-arrow" onClick={this.onClickArrowRight}>
                <i className="fas fa-angle-right edb-xxxlarge"></i>
            </div>}
        </div>);
    }
}

export default ScrollListHorizontal;